/**
 * A dialog opens fresh every time (TMM-B5, FRM-013, TMMRSL-0071). Returns a key that changes each
 * time `open` goes from false to true; the dialog's wrapper passes it as the `key` of the component
 * that holds the state, so reopening shows the initial values, no error and no marked field.
 *
 * It resets on OPEN, not on exit: nothing is cleared while the dialog fades out (no blank or jump
 * mid-animation), and a dialog reopened before its exit finishes is still fresh. The key changes in
 * the render that opens the dialog (the state update is applied before React commits), so the form
 * mounts once, already open.
 */
import { useState } from 'react';

export function useFreshOnOpen(open: boolean): number {
  const [state, setState] = useState({ open, epoch: 0 });
  if (state.open !== open) {
    setState({ open, epoch: open ? state.epoch + 1 : state.epoch });
  }
  return state.epoch;
}
